import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'
import { useLoadingStore } from '@/stores/loading'
import { useSlugHelper } from '@/router/useSlugHelper'

const Names = {
  fr: 'questions-reponses',
  en: 'answers-questions'
}

const Config: TrPageConfigInterface = {
  name: Names.fr,
  path: `/${Names.fr}`,
  alias: `/${Names.en}`,
  meta: {
    title: {
      fr: 'Questions et Reponses',
      en: 'Answers & Questions'
    },
    description: {
      fr: 'Consultez cette page pour prendre connaissance des différentes questions les plus fréquemment posées concernant Clic Santé.',
      en: 'Consult this page for the most frequently asked questions about Clic Santé.'
    }
  },
  props: (route) => ({ query: route.query }),
  component: () => import('@page/faq/FAQ.vue'),
  beforeEnter: async (to, from, next) => {
    const loadingStore = useLoadingStore()
    loadingStore.toggleLoading({ set: true })
    next(await useSlugHelper().checkPageSlug(to.path, Names))
  }
}

export { Config }
